import axios from 'axios';

// axios.defaults.baseURL = 'https://spoddr.transparen.com';

axios.defaults.validateStatus = function (status) {
  return status >= 200 && status < 300;
};

if (process.env.NODE_ENV !== 'production') {
  axios.interceptors.request.use((request) => {
    console.log('>>> Request:', request);
    return request;
  }, (request) => {
    console.log('>>> Request: ERROR:', request);
    return Promise.reject(request);
  });

  axios.interceptors.response.use((response) => {
    console.log('<<< Response:', response);
    return response;
  }, (error) => {
    console.log('<<< Response: ERROR:', error.response);
    return Promise.reject(error);
  });
}



// WEBPACK FOOTER //
// ./src/utils/axiosConfigs.js